import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import HousekeepingStaffWorkspace from "./HousekeepingStaffWorkspace";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

export default class HousekeepingStaff extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          loading: false,
          active_tab: this.props.active_tab,
          housekeeper: this.props.housekeeper,
          all_housekeepers: this.props.all_housekeepers,
          housekeeper_rooms: this.props.housekeeper_rooms,
          all_rooms: this.props.all_rooms,
          all_room_types: this.props.all_room_types,
          housekeeping_staff_rooms_endpoint: this.props.housekeeping_staff_rooms_endpoint,
          data_table_endpoint: this.props.data_table_endpoint,
          assign_housekeeper_path: this.props.assign_housekeeper_path,
          date_format: this.props.date_format,
          time_format: this.props.time_format,
        }
        this.prepParams = this.prepParams.bind(this);
        this.onSubmit = this.onSubmit.bind(this);        
        this.setActiveTab = this.setActiveTab.bind(this);        
        this.onChangeRooms = this.onChangeRooms.bind(this);        
    }


    render() {
       var self = this
        var buttons = [
            {
              name: I18n.t('cancel'),
              html_attributes: ['data-dismiss="modal"']
            },
            {
              name: I18n.t('submit'),
              button_classes: ['primary'],
              onClick: self.onSubmit,
            },
        ]

        if (!this.props.viewOnly) {
            return (
                <div>
                    <Tabs tabs={this.tabs()}/>
                    <div className="panel panel-form">
                        <ModalButtons loading={this.state.loading} buttons={buttons} />
                        <HousekeepingStaffWorkspace {...this.state} onChangeRooms={this.onChangeRooms} />
                        <LoadingSpinner show={this.state.loading} />
                    </div>
                </div>
            );
        }
    }
    
    prepParams() { 
        return (
            {
                rooms: this.state.housekeeper_rooms,
                housekeeper_id: this.state.housekeeper.id,
            }
        )
    }
    
    onSubmit() {
        var self = this
        var params = this.prepParams()
        this.setState({ loading: true});
        $.ajax({
            type: 'PATCH',
            url: self.state.assign_housekeeper_path,
            data: params || null
        }).done(function (data) {
          self.setState({ loading: false });
          if (parent && parent.refresh_data) {
              parent.refresh_data(I18n.t('housekeeper_assigned_successfully'))
          }
          if (parent && parent.hide_modal) {
              parent.hide_modal()
          }
        })    
    }
    
    tabs() {
        var tabs = []
    
        tabs.push({
          tabName: I18n.t('assigned_rooms'),
          targetName: 'assigned_rooms',
          classes: this.state.active_tab === 'assigned_rooms' ? 'active' : null,
          changeHandler: this.setActiveTab,
        })
    
        tabs.push({
          tabName: I18n.t('housekeeping_logs'),
          targetName: 'housekeeping_logs',
          classes: this.state.active_tab === 'housekeeping_logs' ? 'active' : null,
          changeHandler: this.setActiveTab,
        })
    
        return tabs;
    };

    onChangeRooms(selected_rooms) {
        this.setState({housekeeper_rooms: selected_rooms})
    }

    setActiveTab(tab) {
        this.setState({
            active_tab: tab
        });
    };
};